import { atomWithQuery } from 'jotai-tanstack-query';
import { NewbornProgram } from '@/features/programs/model/types';
import { getNewbornProgram } from '../api/getNewbornProgram';

export const fetchNewbornProgramQueryAtom = (initialData: NewbornProgram) =>
    atomWithQuery<NewbornProgram>(() => ({
        queryKey: ['newborn-program'],
        queryFn: async () => {
            return getNewbornProgram();
        },
        initialData,
    }));
